import React, { useState } from 'react';
import { toast } from 'sonner';
import { Save, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function MetaAdsV1ConfigSection({ initialConfig, onSave, saving }) {
  const [config, setConfig] = useState(initialConfig);

  const handleChange = (field, value) => {
    setConfig(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!config.ad_account_id.trim()) {
      toast.error('Meta Ad Account ID é obrigatório');
      return;
    }
    onSave(config);
  };

  return (
    <div className="border rounded-lg p-4 bg-amber-50 border-amber-200">
      <h3 className="font-semibold text-sm text-amber-900 mb-4">Configuração Manual (v1 — Legacy)</h3>

      {/* Ad Account ID */}
      <div className="space-y-1.5 mb-4">
        <Label htmlFor="ad_account_id" className="flex items-center gap-2">
          Meta Ad Account ID
          <span className="text-red-600">*</span>
          {config.ad_account_id && <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />}
        </Label>
        <Input
          id="ad_account_id"
          value={config.ad_account_id}
          onChange={e => handleChange('ad_account_id', e.target.value)}
          placeholder="act_1234567890"
          className="font-mono text-sm"
          disabled={saving}
        />
        <p className="text-xs text-muted-foreground">Formato: act_XXXXXXXXX</p>
      </div>

      {/* Pixel ID */}
      <div className="space-y-1.5 mb-4">
        <Label htmlFor="pixel_id">Meta Pixel ID (Opcional)</Label>
        <Input
          id="pixel_id"
          value={config.pixel_id}
          onChange={e => handleChange('pixel_id', e.target.value)}
          placeholder="123456789012345"
          className="font-mono text-sm"
          disabled={saving}
        />
      </div>

      {/* Campaign ID */}
      <div className="space-y-1.5 mb-4">
        <Label htmlFor="campaign_id">Campaign ID (Opcional)</Label>
        <Input
          id="campaign_id"
          value={config.campaign_id}
          onChange={e => handleChange('campaign_id', e.target.value)}
          placeholder="1234567890"
          className="font-mono text-sm"
          disabled={saving}
        />
      </div>

      {/* Campaign URL */}
      <div className="space-y-1.5">
        <Label htmlFor="campaign_url">Campaign URL (Opcional)</Label>
        <Input
          id="campaign_url"
          value={config.campaign_url}
          onChange={e => handleChange('campaign_url', e.target.value)}
          placeholder="https://example.com/promo"
          className="text-sm"
          disabled={saving}
        />
      </div>

      <Button
        onClick={handleSave}
        disabled={saving}
        size="sm"
        className="gap-2 w-full mt-4"
      >
        <Save className="w-4 h-4" />
        {saving ? 'Salvando...' : 'Salvar Configuração v1'}
      </Button>
    </div>
  );
}
